// Core components
import { Component } from "@angular/core";

// Third party components
import { FieldWrapper } from "@ngx-formly/core";

// Custom components

/**
 * Script start
 */
@Component({
  selector: "formly-horizontal-wrapper",
  templateUrl: "./horizontal-wrapper-type.component.html",
  styleUrls: ["./horizontal-wrapper-type.component.scss"]
})
export class HorizontalWrapperComponent extends FieldWrapper {
}
